import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container mx-auto px-4 md:px-6" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "hidden md:flex items-center space-x-4 lg:space-x-8 flex-1 justify-center" }
const _hoisted_4 = {
  key: 0,
  class: "relative group"
}
const _hoisted_5 = ["href", "onClick"]
const _hoisted_6 = { class: "absolute top-full left-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-200 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50" }
const _hoisted_7 = { class: "py-2" }
const _hoisted_8 = ["href", "onClick"]
const _hoisted_9 = ["href", "onClick"]
const _hoisted_10 = { class: "relative w-48 max-w-xs ml-4" }
const _hoisted_11 = { class: "relative" }
const _hoisted_12 = {
  key: 0,
  class: "absolute top-full left-0 right-0 mt-1 bg-white rounded-lg shadow-lg border border-gray-200 max-h-64 overflow-y-auto z-50"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["href", "onClick"]
const _hoisted_15 = { class: "font-semibold text-safari-black text-sm" }
const _hoisted_16 = { class: "text-xs text-gray-500 mt-1" }
const _hoisted_17 = {
  key: 1,
  class: "px-4 py-3 text-sm text-gray-500 text-center"
}
const _hoisted_18 = {
  href: "https://docs.google.com/forms/d/e/1FAIpQLSfFWo4Kbs87MZuRUMjLMV9fLjF7lfOCwzbFJ_wenR6yuEqAPQ/viewform",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_19 = {
  key: 0,
  class: "md:hidden bg-white shadow-lg"
}
const _hoisted_20 = { class: "px-4 py-4 space-y-3" }
const _hoisted_21 = { class: "relative mb-3" }
const _hoisted_22 = { class: "relative" }
const _hoisted_23 = {
  key: 0,
  class: "absolute top-full left-0 right-0 mt-1 bg-white rounded-lg shadow-lg border border-gray-200 max-h-64 overflow-y-auto z-50"
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = ["href", "onClick"]
const _hoisted_26 = { class: "font-semibold text-safari-black text-sm" }
const _hoisted_27 = { class: "text-xs text-gray-500 mt-1" }
const _hoisted_28 = {
  key: 1,
  class: "px-4 py-3 text-sm text-gray-500 text-center"
}
const _hoisted_29 = {
  key: 0,
  class: "py-2"
}
const _hoisted_30 = ["href", "onClick"]
const _hoisted_31 = { class: "pl-4 mt-2 space-y-2" }
const _hoisted_32 = ["href", "onClick"]
const _hoisted_33 = ["href", "onClick"]
const _hoisted_34 = {
  href: "https://docs.google.com/forms/d/e/1FAIpQLSfFWo4Kbs87MZuRUMjLMV9fLjF7lfOCwzbFJ_wenR6yuEqAPQ/viewform",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(['fixed top-0 w-full z-50 transition-all duration-300', _ctx.scrolled ? 'bg-white shadow-md' : 'bg-primary'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", {
          href: "/",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.push('/')), ["prevent"]))
        }, [...(_cache[12] || (_cache[12] = [
          _createElementVNode("img", {
            src: "/icons/SAFARISTRIVESbgremoved.png",
            alt: "Safari Strives",
            loading: "eager",
            class: "h-16 md:h-20 lg:h-24 object-cover cursor-pointer"
          }, null, -1)
        ]))]),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems, (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: item.id
            }, [
              (item.id === 'about')
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("a", {
                      href: _ctx.getItemHref(item),
                      onClick: _withModifiers(($event: any) => (_ctx.handleNavigation(item)), ["prevent"]),
                      class: _normalizeClass(['cursor-pointer transition-colors text-sm lg:text-base', _ctx.scrolled ? 'text-safari-black hover:text-primary' : 'text-white hover:text-secondary'])
                    }, _toDisplayString(item.label), 11, _hoisted_5),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aboutSubMenu, (subItem) => {
                          return (_openBlock(), _createElementBlock("a", {
                            key: subItem.id,
                            href: subItem.route,
                            onClick: _withModifiers(($event: any) => (_ctx.handleNavigation(subItem)), ["prevent"]),
                            class: "block px-4 py-2 text-sm text-safari-black hover:bg-primary hover:text-white transition-colors cursor-pointer"
                          }, _toDisplayString(subItem.label), 9, _hoisted_8))
                        }), 128))
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: _ctx.getItemHref(item),
                    onClick: _withModifiers(($event: any) => (_ctx.handleNavigation(item)), ["prevent"]),
                    class: _normalizeClass(['cursor-pointer transition-colors text-sm lg:text-base', _ctx.scrolled ? 'text-safari-black hover:text-primary' : 'text-white hover:text-secondary'])
                  }, _toDisplayString(item.label), 11, _hoisted_9))
            ], 64))
          }), 128)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQuery) = $event)),
                onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleSearch && _ctx.handleSearch(...args))),
                onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showSuggestions = true)),
                onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleSearchBlur && _ctx.handleSearchBlur(...args))),
                onKeydown: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleKeydown && _ctx.handleKeydown(...args))),
                type: "text",
                placeholder: "Search pages, programs, topics...",
                class: _normalizeClass(['w-full px-4 py-2 pl-10 rounded-lg text-sm transition-colors', _ctx.scrolled ? 'bg-gray-100 text-safari-black placeholder-gray-500 border border-gray-200' : 'bg-white/20 text-white placeholder-white/70 border border-white/30'])
              }, null, 34), [
                [_vModelText, _ctx.searchQuery]
              ]),
              (_openBlock(), _createElementBlock("svg", {
                class: _normalizeClass(["absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4", _ctx.scrolled ? 'text-gray-500' : 'text-white/70']),
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [...(_cache[13] || (_cache[13] = [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                }, null, -1)
              ]))], 2))
            ]),
            (_ctx.showSuggestions && (_ctx.filteredResults.length > 0 || _ctx.searchQuery.trim()))
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (_ctx.filteredResults.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredResults, (result, index) => {
                          return (_openBlock(), _createElementBlock("a", {
                            key: result.route,
                            href: result.route,
                            onClick: _withModifiers(($event: any) => (_ctx.selectResult(result)), ["prevent"]),
                            class: _normalizeClass(['block px-4 py-3 hover:bg-gray-100 cursor-pointer transition-colors border-b border-gray-100 last:border-b-0', _ctx.selectedIndex === index ? 'bg-gray-50' : ''])
                          }, [
                            _createElementVNode("div", _hoisted_15, _toDisplayString(result.title), 1),
                            _createElementVNode("div", _hoisted_16, _toDisplayString(result.category), 1)
                          ], 10, _hoisted_14))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_17, " No results found for \"" + _toDisplayString(_ctx.searchQuery) + "\" ", 1))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("a", _hoisted_18, [
          _createVNode(_component_Button, {
            variant: _ctx.scrolled ? 'default' : 'outline',
            class: "hidden md:block bg-primary hover:bg-accent text-sm lg:text-base"
          }, {
            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
              _createTextVNode("Get Involved", -1)
            ]))]),
            _: 1
          }, 8, ["variant"])
        ]),
        _createElementVNode("button", {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.mobileMenuOpen = !_ctx.mobileMenuOpen)),
          class: _normalizeClass(["md:hidden", _ctx.scrolled ? 'text-safari-black' : 'text-white'])
        }, [...(_cache[15] || (_cache[15] = [
          _createElementVNode("svg", {
            class: "w-6 h-6",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M4 6h16M4 12h16M4 18h16"
            })
          ], -1)
        ]))], 2)
      ])
    ]),
    (_ctx.mobileMenuOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchQuery) = $event)),
                  onInput: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleSearch && _ctx.handleSearch(...args))),
                  onFocus: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showSuggestions = true)),
                  onBlur: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleSearchBlur && _ctx.handleSearchBlur(...args))),
                  onKeydown: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleKeydown && _ctx.handleKeydown(...args))),
                  type: "text",
                  placeholder: "Search pages, programs, topics...",
                  class: "w-full px-4 py-2 pl-10 rounded-lg text-sm bg-gray-100 text-safari-black placeholder-gray-500 border border-gray-200"
                }, null, 544), [
                  [_vModelText, _ctx.searchQuery]
                ]),
                _cache[16] || (_cache[16] = _createElementVNode("svg", {
                  class: "absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-500",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  })
                ], -1))
              ]),
              (_ctx.showSuggestions && (_ctx.filteredResults.length > 0 || _ctx.searchQuery.trim()))
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    (_ctx.filteredResults.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredResults, (result) => {
                            return (_openBlock(), _createElementBlock("a", {
                              key: result.route,
                              href: result.route,
                              onClick: _withModifiers(($event: any) => (_ctx.selectResult(result)), ["prevent"]),
                              class: "block px-4 py-3 hover:bg-gray-100 cursor-pointer transition-colors border-b border-gray-100 last:border-b-0"
                            }, [
                              _createElementVNode("div", _hoisted_26, _toDisplayString(result.title), 1),
                              _createElementVNode("div", _hoisted_27, _toDisplayString(result.category), 1)
                            ], 8, _hoisted_25))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_28, " No results found for \"" + _toDisplayString(_ctx.searchQuery) + "\" ", 1))
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems, (item) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: item.id
              }, [
                (item.id === 'about')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createElementVNode("a", {
                        href: _ctx.getItemHref(item),
                        onClick: _withModifiers(($event: any) => {_ctx.handleNavigation(item); _ctx.mobileMenuOpen = false}, ["prevent"]),
                        class: "block text-safari-black hover:text-primary cursor-pointer py-2 font-semibold"
                      }, _toDisplayString(item.label), 9, _hoisted_30),
                      _createElementVNode("div", _hoisted_31, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aboutSubMenu, (subItem) => {
                          return (_openBlock(), _createElementBlock("a", {
                            key: subItem.id,
                            href: subItem.route,
                            onClick: _withModifiers(($event: any) => {_ctx.handleNavigation(subItem); _ctx.mobileMenuOpen = false}, ["prevent"]),
                            class: "block text-safari-black hover:text-primary cursor-pointer py-1 text-sm"
                          }, _toDisplayString(subItem.label), 9, _hoisted_32))
                        }), 128))
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: _ctx.getItemHref(item),
                      onClick: _withModifiers(($event: any) => {_ctx.handleNavigation(item); _ctx.mobileMenuOpen = false}, ["prevent"]),
                      class: "block text-safari-black hover:text-primary cursor-pointer py-2"
                    }, _toDisplayString(item.label), 9, _hoisted_33))
              ], 64))
            }), 128)),
            _createElementVNode("a", _hoisted_34, [
              _createVNode(_component_Button, { class: "w-full bg-primary hover:bg-accent" }, {
                default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                  _createTextVNode("Get Involved", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}